import * as angular from 'angular';
import {
    embedded,
    hideModalBackground,
    showModalBackground
} from 'angular/utils/config';

(function () {
    'use strict';

    angular.module('app').directive('pkpModal', pkpModal);

    /**
     * @author bjnowak.btc
     * @ngInject
     */
    function pkpModal() {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                id: '@',
                label: '@',
                onClose: '&'
            },
            template: require('app/_directives/pkp-modal.directive.html'),
            link(scope, element, attrs) {
                if (!embedded) return;

                const reactBody = window.parent.document.body;

                const onReactClick = () =>
                    document.getElementById(`modal_${scope.id}_close`).click();

                element.on('show.bs.modal', (e) => {
                    showModalBackground();
                    reactBody.addEventListener('click', onReactClick);
                });

                element.on('shown.bs.modal', (e) => {
                    window.parent.scrollTo(0, 0);
                });

                element.on('hide.bs.modal', (e) => {
                    hideModalBackground();
                    reactBody.removeEventListener('click', onReactClick);
                });
            }
        };
    }
})();
